// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"164":"cab67222","312":"238e6da2"}[chunkId] + ".css";
};